// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1KMXT","title":"Info_title__2u5Vn","selects":"Info_selects__3wnH4","requiredAsterisk":"Info_requiredAsterisk__3xG34"};